import { LicenseException } from '@/domain/licensing/exception/LicenseException'

export class LicenseMaximumActivationReachedException extends LicenseException
{

}
